import * as React from 'react';
import { InputHTMLAttributes, ReactNode } from 'react';
import 'src/shared/components/ui/inputs/core.scss';
import { Label } from 'src/shared/components/typography/Label';
import { cn } from 'src/shared/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement>, WithTestId {
  label?: string | ReactNode;
  guidanceText?: ReactNode;
  disable1Password?: boolean;
  disableGrammarly?: boolean;
  endadornment?: ReactNode;
  beginadornment?: ReactNode;
  className?: string;
}

export default function InputWithLabel({
  label,
  guidanceText,
  disable1Password = true,
  disableGrammarly = true,
  endadornment,
  beginadornment,
  readOnly,
  className,
  ...props
}: InputProps) {
  // Generate ID only for string labels
  const id = typeof label === 'string' ? label?.replace(' ', '') : undefined;

  return (
    <div className={cn('w-full h-fit group flex flex-col gap-1', className)}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <div
        className={cn(
          'w-full relative flex items-center border h-9 rounded-sm input-focus',
          readOnly && '!bg-neutral-50 pointer-events-none'
        )}
      >
        {beginadornment && <div className="h-full flex-center pl-3">{beginadornment}</div>}
        <input
          id={id}
          readOnly={readOnly}
          className={cn(
            'input-core input-core-style border-none !h-8',
            readOnly && '!bg-neutral-50 pointer-events-none'
          )}
          {...props}
          data-1p-ignore={disable1Password}
          data-gramm={disableGrammarly ? 'false' : undefined}
          data-gramm_editor={disableGrammarly ? 'false' : undefined}
          data-enable-grammarly={disableGrammarly ? 'false' : undefined}
          spellCheck={disableGrammarly ? 'false' : undefined}
        />
        {endadornment && <div className="h-full flex-center px-3">{endadornment}</div>}
      </div>

      {guidanceText && <p className="text-xs text-typography-grey mt-0.5">{guidanceText}</p>}
    </div>
  );
}
